const Theme = {
  colors: {
    /* APPLYING NEW DESIGN */
    primary: '#FF5500',
    primaryDark: '#F55200',
    orangeDark: '#CA4300',
    orangeLight: '#FFDDCC',
    violet: '#3A0C3D',
    violetDark: '#2F0D31',
    violetLight: '#681DA8',
    yellow: '#FFDB5E',
    feedbackWrong: '#C60024',
    accessibleGreen: '#008A00',
    feedbackOk: '#34BE34',
    blue: '#3A61EA',
    blueLight: '#458B9B',
    blueDark: '#252A49',
    black: '#000000',
    white: '#FFFFFF',
    grayDark: '#68808C',
    grayDarkLight: '#53768A',
    grayMediumDark: '#7C98A7',
    grayMediumLight2: '#B9B9B9',
    grayMediumLight: '#CBD6DC',
    grayMedium: '#E7EEF0',
    grayLight: '#F3F7F8',
    lightRed: '#FFEFF2',
    lightGreen: '#DFFFDF',
    reservedOrange: '#DD5511',
    reservedOrangeLight: '#FFF2EB',
    purple: '#513F84',
    purpleLight: '#8774D2',
    purpleDark: '#510059',
    alertRed: '#F1DFE3',
    brownYellow: '#B1860C',
    greenVaMx: '#C4D600',
    yellowVaMx: '#FFC72C',
    redVaMx: '#CF3239',
    blueVaMx: '#037CC2',
    disabledVaMx: '#969899',

    /* BRAND COLORS */
    whatsapp: '#25D366',
    navent: '#5200BA',
    /* OLD DESIGN - Check this */
    primaryDarker: '#762e04',
    primaryLight: '#fbb68f',
    primaryLighter: '#feebeb',
    gray100: '#001226',
    gray75: '#334151',
    gray50: '#66717d',
    gray25: '#ccd0d4',
    gray5: '#fafafb',
    blue100: '#012752',
    blue75: '#034695',
    blue50: '#0366db',
    blue25: '#66acfd',
    blue5: '#ecf5ff',
    red105: '#c60024',
    red100: '#640706',
    red75: '#a40c0a',
    red50: '#e4100e',
    red25: '#f78483',
    red5: '#fde3e3',
    green100: '#154219',
    green75: '#26762c',
    green50: '#36a93f',
    green25: '#8cda93',
    green5: '#e7f7e8',
    violet100: '#520f9a',
    violet75: '#7215d8',
    violet50: '#9544ed',
    violet25: '#dbc0f9',
    violet5: '#f6eefd',
    pink100: '#a81253',
    pink75: '#ed5497',
    pink50: '#e51872',
    pink25: '#facfe2',
    pink5: '#fdeef4',
    yellow50: '#ffc400',
    yellow25: '#ffe380',
    yellow5: '#fffae6',
    neutralMediumGray: '#c8c8c8',
    darkRed: '#A30A10'
  },
  fontFamily: "'Hind', sans-serif"
};

export const withColor = key => props => props.theme.colors[key];
export const selectColor = key => Theme.colors[key];

export default Theme;
